export const TRIP_TABS = {
  EXPLORE: 'explore',
  TRIPS: 'trips',
  BOOKINGS: 'bookings',
  RESERVATIONS: 'reservations',
  TRANSACTIONS: 'transactions',
} as const;

export type TripTabKey = typeof TRIP_TABS[keyof typeof TRIP_TABS];

export const TAB_CONFIG = [
  { key: TRIP_TABS.EXPLORE, label: 'Explore', path: '#explore' },
  { key: TRIP_TABS.TRIPS, label: 'Trips', path: '#trips' },
  { key: TRIP_TABS.BOOKINGS, label: 'Bookings', path: '#bookings' },
  { key: TRIP_TABS.RESERVATIONS, label: 'Reservations', path: '#reservations' },
  { key: TRIP_TABS.TRANSACTIONS, label: 'Transactions', path: '#transactions' },
];

export const getTabIndex = (tabKey: TripTabKey): number => {
  return TAB_CONFIG.findIndex(tab => tab.key === tabKey);
};

export const getTabKey = (index: number): TripTabKey | null => {
  const tab = TAB_CONFIG[index];
  return tab ? tab.key : null;
};

export const isValidTabKey = (key: string): key is TripTabKey => {
  return Object.values(TRIP_TABS).includes(key as TripTabKey);
};

export const getTabPath = (tabKey: TripTabKey): string => {
  const tab = TAB_CONFIG.find(tab => tab.key === tabKey);
  return tab ? tab.path : '#explore';
};

export const getTabLabel = (tabKey: TripTabKey): string => {
  const tab = TAB_CONFIG.find(tab => tab.key === tabKey);
  return tab ? tab.label : 'Unknown';
};
